import { ApiHandlerResult } from '..'
import { NEXT_API_URL } from '@/constants'
import { BaseApi } from '../base'
import { Fetcher } from '@/api/fetcher'

export class ListingPathApi extends BaseApi {
  constructor(fetcher: Fetcher) {
    super(fetcher)
  }

  // Brings the listing's profile path history up to date after a save made
  // through Express, which can change the slug or category without it.
  async sync(listingId: number): ApiHandlerResult<{ changed: boolean }> {
    try {
      const res = await this.fetcher.post(
        NEXT_API_URL.LISTING_PATH(listingId),
        {
          credentials: 'include',
        }
      )

      return await this.parseBodyOrThrow(res)
    } catch (error: any) {
      return [error, null]
    }
  }
}
